import { Building2, Cake, Store, UtensilsCrossed } from "./icons";
import { Link } from "react-router-dom";
import Breadcrumbs from "./Breadcrumbs";
import SectionHeading from "./SectionHeading";
import { useLanguage } from "../context/LanguageContext";

export default function ThemesPage() {
  const { t } = useLanguage();

  const themes = [
    {
      icon: Store,
      title: t("theme1Title"),
      description: t("theme1Desc"),
      href: "/catalog?category=Thermal",
    },
    {
      icon: Building2,
      title: t("theme2Title"),
      description: t("theme2Desc"),
      href: "/catalog?category=Industrial",
    },
    {
      icon: UtensilsCrossed,
      title: t("theme3Title"),
      description: t("theme3Desc"),
      href: "/catalog?category=ServingLines",
    },
    {
      icon: Cake,
      title: t("theme4Title"),
      description: t("theme4Desc"),
      href: "/catalog?category=Bakery",
    },
  ];

  return (
    <section className="bg-white pb-24 pt-24 md:pb-32 md:pt-32">
      <Breadcrumbs items={[{ label: t("themesPageTitle") }]} />
      <div className="container-industrial pt-16">
        <SectionHeading title={t("themesPageTitle")} description={t("themesPageDescription")} />

        <div className="mt-16 grid grid-cols-1 gap-px border border-steel-200 bg-steel-200 sm:grid-cols-2">
          {themes.map(({ icon: Icon, title, description, href }) => (
            <Link
              key={title}
              to={href}
              className="group flex flex-col gap-4 bg-white p-8 transition-colors duration-200 ease-engineered hover:bg-steel-50"
            >
              <span className="flex h-11 w-11 items-center justify-center bg-accent/8 text-accent">
                <Icon size={20} />
              </span>
              <div>
                <h3 className="font-sans text-base font-semibold text-ink">{title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-steel-600">{description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
